<template>
    <q-dialog v-if="dataReceived" v-model="showInteractionInformation" @hide="closeDialog">
        <q-card style="min-width: 80vw">
            <h6 class="q-ml-md">
                {{ clientView.first_name }} {{ clientView.last_name }}
            </h6>

            <div class="client-interaction-header">
                <q-card-section class="flex-box text-bold">
                    Time Spent In Interactions: {{ clientTimeEngaged }}
                </q-card-section>
            </div>
            <q-card-section>
                <div class="interaction-graphs">
                    <div v-if="interactionChartData" class="graph-chart large-graph">
                        <Pie v-bind:chartData="this.interactionChartData" v-bind:chartOptions="interactionChartOptions" />
                    </div>
                </div>
            </q-card-section>
            <q-card-section>
                <q-btn v-if="contactDescriptions" class="q-mr-md" outline no-caps color="primary" label="View Contact Descriptions" @click="showDescriptions = !showDescriptions">
                    <q-popup-proxy style="border-radius: 15px;">
                        <q-card>
                            <q-card-section v-for="description in contactDescriptions" :key="description">
                                {{ description }} 
                            </q-card-section>
                        </q-card>
                    </q-popup-proxy>
                </q-btn>
                <q-btn v-if="contactDescriptions" outline no-caps color="secondary" :label="`View ${clientView.first_name}'s Active Profile`">
                    <q-popup-proxy>
                        <ActivePersonProfileComponent :personId="clientRow.person_id" />
                    </q-popup-proxy> 
                </q-btn>
            </q-card-section>
            <div>
                <TableFilterComponent :tableInformation="clientInteractionData" :filterKeys="['Contact Type', 'Programme', 'Service']" @updateFilters="updateFilters" />
                <q-table class="q-pa-md" :style="{ height: '800px' }" :rows="filteredRows" :columns="columns"
                    :rows-per-page-options="[15]">

                    <template v-slot:top-right>
                        <q-btn no-caps fab-mini flat icon="download" @click="exportTable(filteredRows, `${clientView.first_name} ${clientView.last_name} - Interactions.csv`, { columns })" />
                    </template>

                    <template v-slot:body-cell="props">
                        <q-td :props="props">
                            <span v-if="props.col.name.includes('date')">
                                {{ props.value.split('T')[0] }}
                            </span>
                            <span v-else>
                                {{ props.value }}
                            </span>
                        </q-td>
                    </template>
                </q-table>
            </div>
        </q-card>
    </q-dialog>
    <q-inner-loading v-else showing color="primary" />
</template>

<script>

import api from "../../../services/api/api"
import notify from '@/services/util/notify';
import Pie from "../../ChartComponents/Pie.vue";
import { retPieOptions } from "../../DataComponents/chartOptions"

import TableFilterComponent from "../TableFilterComponent.vue";
import ActivePersonProfileComponent from "./ActivePersonProfileComponent.vue";

import { exportTable } from "../../../services/util/file";

export default {
    name: "ClientInteractionComponent",

    components: { Pie, TableFilterComponent, ActivePersonProfileComponent },

    props: {
        clientRow: {
            type: Object,
            required: true
        }
    },

    data() {    
        return {
            exportTable: exportTable,
            showDescriptions: false,

            showInteractionInformation: false,
            dataReceived: false,

            clientView: {},
            clientInteractionData: {},
            columns: [],

            selectedFilters: {},

            contactDescriptions: null,

            interactionChartData: null,
            interactionChartOptions: retPieOptions("Interaction Time By Contact Type (Hours)", "Contact Type"),
        }
    },

    computed: {

        /**
         * Created formatted string for time spent in interactions.
         */
        clientTimeEngaged() {
            let totalMinutes = 0;

            for (const element of this.clientInteractionData) {
                const minutes = Number.parseInt(element.total_minutes);
                if (!isNaN(minutes)) {
                    totalMinutes += minutes;
                }
            }

            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;

            const formattedTime = `${hours} hours : ${minutes.toString().padStart(2, '0')} minutes`;
            return formattedTime;
        },

        /**
         * Generate filtered rows by applying selected filters to client data
         */
        filteredRows() {
            if (this.clientInteractionData.length == 0) {
                return this.clientInteractionData;
            }

            return this.clientInteractionData.filter((row) => {
                return Object.keys(this.selectedFilters).every((key) => {

                    if (this.selectedFilters[key].length === 0) {
                        return true;
                    }
                    return this.selectedFilters[key].includes(row[key]);
                });
            });
        },
    },


    created() {
        this.retrieveInteractionData(this.clientRow);
    },


    methods: {

        /**
         * Retrieves interaction data for a given client.
         * @param {*} row 
         */
        retrieveInteractionData(row) {
            this.showInteractionInformation = true;
            this.dataReceived = false;

            api.client.getInteractionDataByClientId(row.client_id).then((res) => {
                this.clientInteractionData = res.data.tableRows;
                this.columns = res.data.tableColumns
                this.contactDescriptions = res.data.contactDescriptions;
                this.clientView = row;
                this.showInteractionInformation = true;
                this.dataReceived = true;
                this.interactionChartData = res.data.pieData;
            }).catch((error) => {
                this.closeDialog();
                notify.error(error.message, 'top');
            })
        },


        updateFilters(filters) {
            this.selectedFilters = filters;
        },


        /**
         * Resets the cards appearance and default values.
         */
        closeDialog() {
            this.$emit('close')
        }
    }
}

</script>
